export default "__VITE_ASSET__CXAhlR2O__"